/* Find your fit quiz (Oct 25, 2026, CRO, KB 16.158). Two questions, one pick, Add to cart through /cart/add.js. No app, no library. */
(function () {
  var PICK = {
    energy:     { spray: 'nad-nasal-spray', caps: 'enhanced-nmn-nicotinamide-mononucleotide', pair: { 'nad-nasal-spray': 'theanine-nasal-spray', 'enhanced-nmn-nicotinamide-mononucleotide': 'nad-nasal-spray' } },
    focus:      { spray: 'methyl-b-12-nasal-spray', caps: 'clarity', pair: { 'methyl-b-12-nasal-spray': 'nad-nasal-spray', 'clarity': 'nad-nasal-spray' } },
    sleep:      { spray: 'melatonin-nasal-spray', caps: 'melatonin-nasal-spray', pair: { 'melatonin-nasal-spray': 'theanine-nasal-spray' } },
    mood:       { spray: 'theanine-nasal-spray', caps: 'anandamide-supplement', pair: { 'theanine-nasal-spray': 'anandamide-supplement', 'anandamide-supplement': 'theanine-nasal-spray' } },
    aging:      { spray: 'glutathione-nasal-spray', caps: 'enhanced-nmn-nicotinamide-mononucleotide', pair: { 'glutathione-nasal-spray': 'nad-nasal-spray', 'enhanced-nmn-nicotinamide-mononucleotide': 'glutathione-nasal-spray' } },
    metabolism: { spray: 'oea-supplement', caps: 'oea-supplement', pair: { 'oea-supplement': 'berberine-with-ceylon-cinnamon' } }
  };
  var NOTE = { sleep: { caps: 'Our sleep pick comes as a nasal spray.' }, metabolism: { spray: 'Our metabolism pick comes as capsules.' } };

  function init(root) {
    if (!root || root.__shq) return;
    root.__shq = true;
    var state = { goal: null, format: null };
    var step = root.querySelector('[data-shq-step]'), bar = root.querySelector('[data-shq-bar]');

    function show(n) {
      var qs = root.querySelectorAll('[data-shq-q]');
      for (var i = 0; i < qs.length; i++) qs[i].hidden = qs[i].getAttribute('data-shq-q') !== String(n);
      step.textContent = n < 3 ? 'Question ' + n + ' of 2' : 'Your match';
      bar.style.width = (n === 1 ? 33 : n === 2 ? 66 : 100) + '%';
      var first = root.querySelector('[data-shq-q="' + n + '"] .shq__opt, [data-shq-q="' + n + '"] .shq__result:not([hidden]) .shq__name a');
      if (first && root.__shqKey) first.focus({ preventScroll: true });
    }

    function result() {
      var g = PICK[state.goal];
      var f = state.format === 'caps' ? 'caps' : 'spray';
      var h = g[f];
      var rs = root.querySelectorAll('[data-shq-result]'), card = null;
      for (var i = 0; i < rs.length; i++) {
        var on = rs[i].getAttribute('data-shq-result') === h;
        rs[i].hidden = !on;
        if (on) card = rs[i];
      }
      if (!card) { show(1); return; }
      var note = NOTE[state.goal] && NOTE[state.goal][state.format];
      var forEl = card.querySelector('[data-shq-for]');
      forEl.textContent = note || '';
      forEl.hidden = !note;
      var pairBox = card.querySelector('[data-shq-pair]');
      var ph = g.pair[h], pc = ph && root.querySelector('[data-shq-result="' + ph + '"]');
      pairBox.innerHTML = '';
      if (pc) {
        var img = document.createElement('img');
        img.src = pc.getAttribute('data-img'); img.alt = ''; img.width = 64; img.height = 64; img.loading = 'lazy';
        var p = document.createElement('p');
        var a = document.createElement('a');
        a.href = pc.getAttribute('data-url'); a.className = 'shq__link'; a.textContent = 'See ' + pc.getAttribute('data-title');
        var t = document.createElement('b'); t.textContent = 'Pairs well with ' + pc.getAttribute('data-title') + ', from ' + pc.getAttribute('data-price');
        p.appendChild(t); p.appendChild(document.createTextNode(pc.getAttribute('data-ben') + ' ')); p.appendChild(a);
        pairBox.appendChild(img); pairBox.appendChild(p);
        pairBox.hidden = false;
      } else {
        pairBox.hidden = true;
      }
      show(3);
    }

    root.addEventListener('click', function (e) {
      var o = e.target.closest('.shq__opt, [data-shq-back], [data-shq-restart]');
      if (!o || !root.contains(o)) return;
      root.__shqKey = e.detail === 0; /* keyboard activation: move focus to the next step; mouse and touch: leave it */
      if (o.hasAttribute('data-goal')) { state.goal = o.getAttribute('data-goal'); show(2); }
      else if (o.hasAttribute('data-format')) { state.format = o.getAttribute('data-format'); result(); }
      else if (o.hasAttribute('data-shq-back')) { show(1); }
      else if (o.hasAttribute('data-shq-restart')) { state = { goal: null, format: null }; show(1); }
    });

    root.addEventListener('change', function (e) {
      var f = e.target.closest('[data-shq-form]');
      if (f && e.target.name === 'selling_plan') reset(f);
    });

    /* Window capture phase, so the cart drawer app's own submit handler does not take over the form first. */
    window.addEventListener('submit', function (e) {
      var f = e.target.closest && e.target.closest('[data-shq-form]');
      if (!f || !root.contains(f) || !window.fetch) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var btn = f.querySelector('.shq__add'), view = f.querySelector('.shq__view'), msg = f.querySelector('.shq__msg');
      var item = { id: +f.elements.id.value, quantity: 1 };
      var plan = f.querySelector('input[name="selling_plan"]:checked');
      if (plan && plan.value) item.selling_plan = +plan.value;
      btn.disabled = true;
      msg.textContent = 'Adding to your cart';
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function () {
        f.classList.add('is-added');
        view.setAttribute('tabindex', '0');
        msg.textContent = plan && plan.value ? 'Added to your cart as a subscription.' : 'Added to your cart.';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var B = window.Boost && window.Boost.Cart;
        if (B && B.refresh) B.refresh();
        if (B && B.open) B.open(); else view.focus();
      }).catch(function (err) {
        msg.textContent = (err && err.description) || 'Sorry, that did not work. Please try again.';
      }).then(function () {
        btn.disabled = false;
      });
    }, true);

    function reset(f) {
      f.classList.remove('is-added');
      f.querySelector('.shq__view').setAttribute('tabindex', '-1');
      f.querySelector('.shq__msg').textContent = '';
    }
    show(1);
  }

  function all(scope) {
    var r = (scope || document).querySelectorAll('[data-shq]');
    for (var i = 0; i < r.length; i++) init(r[i]);
  }
  all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
